"use strict"; // These are copied from the service as are not expected to change frequently
// in order to avoid pulling in the service dependency into consumers

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var client_library_1 = require("@seneca/client-library");

var consts_1 = require("../consts");

function constructTransformersString(transformers) {
  return Object.keys(transformers).reduce(function (acc, key) {
    var shortParamName = consts_1.ReverseTransformersMap[key];

    if (!shortParamName) {
      throw new client_library_1.InvalidParamError(key);
    }

    var encodedTransformerValue = encodeURIComponent(transformers[key]);
    return [].concat(_toConsumableArray(acc), ["".concat(shortParamName, "_").concat(encodedTransformerValue)]);
  }, []).sort().join(',');
}

exports["default"] = constructTransformersString;